/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1792
 */

function n(t, r) {
  module.exports = n = Object.setPrototypeOf || function (e, t) {
    e.__proto__ = t
    return e
  }
  return n(t, r)
}
module.exports = n
